module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "flex-content"
  }, [_c('group', {
    attrs: {
      "title": "设置手机号"
    }
  }, [_c('x-input', {
    staticStyle: {
      "padding-top": "10px"
    },
    attrs: {
      "title": "手机号:",
      "placeholder": "请输入11位手机号码",
      "max": 11,
      "readonly": _vm.readonly
    },
    model: {
      value: (_vm.number),
      callback: function($$v) {
        _vm.number = $$v
      },
      expression: "number"
    }
  })], 1), _vm._v(" "), _c('group', [_c('x-input', {
    attrs: {
      "title": "验证码:",
      "placeholder": "请输入6位验证码",
      "max": 6
    },
    model: {
      value: (_vm.code),
      callback: function($$v) {
        _vm.code = $$v
      },
      expression: "code"
    }
  }), _vm._v(" "), _c('x-button', {
    staticStyle: {
      "float": "right",
      "margin-right": "10px !important"
    },
    attrs: {
      "type": "primary",
      "mini": "",
      "disabled": _vm.canNotGetCode
    },
    nativeOn: {
      "click": function($event) {
        _vm.getCode($event)
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.getCodeBtnText) + "\n            ")])], 1), _vm._v(" "), _c('group', {
    staticStyle: {
      "margin": "0 10px"
    }
  }, [_c('x-button', {
    attrs: {
      "type": "warn",
      "disabled": _vm.canNotSubmit
    },
    nativeOn: {
      "click": function($event) {
        _vm.submit($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.submitBtnText))]), _vm._v(" "), _c('x-button', {
    attrs: {
      "type": "default",
      "link": "/uc/index"
    }
  }, [_vm._v("返回个人中心")])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9b5b44c4"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/uc/SetMobile.vue
// module id = 726
// module chunks = 0